import type { MultiselectCustomerPartialEntity } from '../../global/ConfigurationMultiselect/configurationMultiselectTypes';

export interface ScopeActiveEntitySource {
  code?: string | null;
  id: number;
  name: string;
}

export interface ScopeActiveEntityCollections {
  brands: ScopeActiveEntitySource[];
  departments: ScopeActiveEntitySource[];
  regions: ScopeActiveEntitySource[];
  skuClasses: ScopeActiveEntitySource[];
  stores: ScopeActiveEntitySource[];
  storeTypes: ScopeActiveEntitySource[];
}

export interface ScopeRuleMultiselectEntity extends MultiselectCustomerPartialEntity {
  isInactive?: boolean;
}

const toMultiselectEntity = (
  item: ScopeActiveEntitySource,
  isInactive = false,
): ScopeRuleMultiselectEntity => ({
  id: item.id,
  customerId: item.id.toString(),
  title: item.name,
  code: item.code,
  isInactive: isInactive || undefined,
});

export const toScopeActiveEntityOptions = (
  active: ScopeActiveEntitySource[],
  complete: ScopeActiveEntitySource[],
  selectedIds: number[],
): ScopeRuleMultiselectEntity[] => {
  const completeById = new Map(complete.map(item => [item.id, item]));
  const includedIds = new Set<number>();
  const result: ScopeRuleMultiselectEntity[] = [];

  active.forEach(item => {
    if (includedIds.has(item.id)) return;

    includedIds.add(item.id);
    result.push(toMultiselectEntity(item));
  });

  selectedIds.forEach(id => {
    if (includedIds.has(id)) return;

    includedIds.add(id);
    const completeItem = completeById.get(id);
    result.push(
      completeItem
        ? toMultiselectEntity(completeItem, true)
        : {
            id,
            customerId: id.toString(),
            title: `#${id}`,
            label: `#${id}`,
            isInactive: true,
          },
    );
  });

  return result;
};
